// SpecializedInHomeSupportSection.js
import React from "react";
import specializedInHomeSupportImage from "../assets/specialized-in-home-support-image.jpg";

const SpecializedInHomeSupportSection = () => {
  const services = [
    "Safe transitions from hospital or rehab to home",
    "Emotional support and companionship for both clients and families",
    "Assistance for those living with long-term or chronic illnesses",
    "Care for individuals managing Parkinson's disease or other neurological conditions",
    "Support for adults living with physical or cognitive disabilities",
  ];

  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={specializedInHomeSupportImage}
              alt="Caregiver embracing elderly woman"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Specialized In-Home Support for Recovery and Long-Term Care
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Managing health challenges or transitioning home after
                hospitalisation can be overwhelming without the right support.
                At Allawah Lodge, our specialty care services are designed to
                make that journey smoother, safer, and more comfortable. Whether
                you're recovering from surgery, living with a disability, or
                managing a chronic condition, our trained caregivers provide
                attentive, compassionate care that promotes independence and
                peace of mind.
              </p>

              <p className="font-normal">
                We assist clients across a wide range of needs, including:
              </p>
            </div>

            <ul className="space-y-2 text-gray-700 font-light">
              {services.map((service, index) => (
                <li key={index} className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecializedInHomeSupportSection;
